(function () {
  'use strict';

  angular.module('eclipseApp.checkout')

    .factory('buyUtils', ['$q', '$rootScope', 'provinceMeta', 'uteLocale', function ($q, $rootScope, provinceMeta, uteLocale) {

      var cancelRequest = $q.defer();

      var buyUtils = {
        // TODO deprecate .getAppLang in buyService and use buyUtils.getAppLang
        getAppLang: function(){
          var lang;

          if (uteLocale &&
              _.isString(uteLocale.language)){

            lang = uteLocale.language;
          }
          else if ($rootScope &&
              $rootScope.userPref &&
              _.isString($rootScope.userPref.language)) {

            lang = $rootScope.userPref.language;
          }
          else {

            lang = 'en';
          }

          return lang.toLowerCase();
        },
        getAppRegion: function(){
          var region;

          if (uteLocale &&
              _.isString(uteLocale.province)) {

            region = uteLocale.province;
          }
          else if ($rootScope &&
                   $rootScope.userPref &&
                   _.isString($rootScope.userPref.province)) {

            region = $rootScope.userPref.province;
          } else {
            region = 'on';
          }

          return region.toLowerCase();
        },
        getAge: function (dateString) {

          if (dateString) {
            var dob = dateString.year + '-' + dateString.month + '-' + dateString.day;

            if (!dateString.day || !dateString.year || !dateString.month) return;

            // console.log('@buyUtils:getAge (dateString) ', dateString);

            var today = moment().format();
            var birthDate = moment(dob, 'YYYY-MM-DD').format();

            if (!moment(today).isValid() || !moment(birthDate).isValid()) return;

            // console.log('@buyUtils:getAge 1 (birthDate, today) ', birthDate, today);
            var age = moment(today).get('year') - moment(birthDate).get('year');
            // console.log('@buyUtils:getAge 2 (age) ', age);
            var m = moment(today).get('month') - moment(birthDate).get('month');
            // console.log('@buyUtils:getAge 3 (m) ', m);
            if (m < 0 || (m === 0 && moment(today).get('date') < moment(birthDate).get('date'))) {
              age--;
            }
            // console.log('@buyUtils:getAge 4 (age) ', age);
            return age;
          }
        },
        isDobValid: function (dateObj) {
          var _prov =  buyUtils.getAppRegion();

          var dob = dateObj.year + '-' + dateObj.month + '-' + dateObj.day,
            age = buyUtils.getAge(dateObj),
            ageOfMajority = 18;

          // console.log('@buyUtils:isDobValid (age) ', age);

          // set ageOfMajority base on province
          if (provinceMeta && $rootScope.userPref && _prov) {
            for (var prov in provinceMeta) {

              if (_prov === prov) {
                ageOfMajority = provinceMeta[prov].ageOfMajority;
              }

            }
          } else {
            console.log('FAILED TO SET AGE OF MAJORITY BASE ON PROVINCE: EITHER RUI.PROVINCE OR THE PROVINCE_META IS UNDEFINED');
          }

          if (moment(dob, 'YYYY-MM-DD').isValid()) {
            // console.log('yayaya (are, aom) ', age, ageOfMajority);

            return (age >= ageOfMajority);
          }
          else {
            return false;
          }
        },

        cancelOperation: function (promise) {
          cancelRequest.resolve();
        },
        resetDeferredRequest: function () {

          /*
           * @method resetDeferredRequest
           * @description reset promise object after timeout delay was reached.
           * Used by notifier.js for cancelling http request after a defined delay.
           *
           */

          cancelRequest = $q.defer();

          // reinitialized reference for controller consumers
          buyUtils.deferredCancelRequest = cancelRequest;
        },
        deferredCancelRequest: cancelRequest,

        setCardExpiry: function (dateObj) {
          if (dateObj.month < 10) {
            dateObj.month = '0' + dateObj.month;
          } else {
            dateObj.month;
          }

          if (dateObj.day < 10) {
            dateObj.day = '0' + dateObj.day;
          } else {
            dateObj.day;
          }

          if (dateObj.day) {
            return dateObj.year + '-' + dateObj.month + '-' + dateObj.day;
          } else {
            return dateObj.year + '-' + dateObj.month;
          }
        },

        isValidLeapYearDate: function (year, month, day) {
          var d = Number(day),
            m = Number(month),
            y = Number(year);

          if (!moment([y]).isLeapYear() && (m === 2) && (d >= 29)) {
            return false;
          } else {

            // if its a leap year and invalidate dates 30-31 when on feb
            if ((m === 2) && (d > 29)) {
              return false;
            } else {
              return true;
            }
          }
        },

        isDayInMonth: function (month, day) {
          month = Number(month);
          day = Number(day);
          var monthEnds = {
            has31: [1, 3, 5, 7, 8, 10, 12],
            has30: [2, 4, 6, 9, 11]
          };

          // console.log('@isDayInMonth():beforeIf: M,D,has31', month, day, (monthEnds.has31.indexOf(month) !== -1));

          // if month is not in has31 and day is 31 -> false

          if ((monthEnds.has31.indexOf(month) === -1) && (day === 31)) {
            // console.log('@isDayInMonth():if: M,D', month, day, (monthEnds.has31.indexOf(month) === -1));
            return false;
          } else {
            return true;
          }
        },

        formatPhoneNumber: function (number) {

          if (!number) return;

          number = number.toString();

          if (number.indexOf('.') > 0) {
            number = number.split('.').join('');
          } else if (number.indexOf(' ') > 0) {
            number = number.split(' ').join('');
          } else if (number.indexOf('-') > 0) {
            number = number.split('-').join('');
          }

          return number;
        },


        getCCType: function (param) {

          var byFirstCharTypes = {
            V: 'VISA',
            M: 'MASTER',
            A: 'AMEX'
          };

          var byFullCCNames = {
            VISA: 'V',
            MASTERCARD: 'M',
            MASTER: 'M',
            AMEX: 'A'
          };

          return {
            byFirstChar: function (firstLetter) {

              if (firstLetter in byFirstCharTypes) {
                return byFirstCharTypes[firstLetter];
              }

            },
            byName: function (name) {
              if (name) {
                switch (name) {
                  case 'MASTERCARD':
                    return 'MASTER';
                  default:
                    return name;
                }
              } else {
                console.log('@formatCCType:@param missing type or invalid.');
                return null;
              }
            },
            byFullCCName: function (fullCCName) {
              if (fullCCName in byFullCCNames) {
                return byFullCCNames[fullCCName];
              } else {
                console.log('@formatCCType:@param invalid CCType full name.');
                return fullCCName;
              }
            }
          };
        },

        formatNumber: function (num) {
          if (num < 10) {
            num = '0' + num;
          }
          return num;
        },

        /*
         * @function isValidExpiryDate -> Bool
         * @description Helper function to check if selected-date is valid relative to current-date
         *
         * @param dateObj:Object
         *    dateObj.year
         *    dateObj.month
         *    dateObj.day
         *
         */
        isValidExpiryDate: function (dateObj) {

          var date = dateObj.year + '-' + ((dateObj.month.length === 1) ? ('0' + dateObj.month) : dateObj.month) + '-' + ((dateObj.day.length === 1) ? ('0' + dateObj.day) : dateObj.day);

          return (moment(date, 'YYYY-MM-DD').isValid() && (moment(date, 'YYYY-MM-DD')).diff(moment(), 'days') > -1);
        },

        isValidDate: function (dateObj) {

          var date = dateObj.year + '-' + ((dateObj.month.length === 1) ? ('0' + dateObj.month) : dateObj.month) + '-' + ((dateObj.day.length === 1) ? ('0' + dateObj.day) : dateObj.day);

          return (moment(date, 'YYYY-MM-DD').isValid());
        },

        validateSin: function (sinStr) {
          sinStr = sinStr || '';

          var initEvenIndex = 1,
            initOddIndex = 0,
            checkDigit,
            allNumArr,
            oddNums, evnNums,
          // oddArr, evnArr,
            grandSum, checkSum;

          if (angular.isNumber(sinStr)) {

            /*
             * @if
             * @param sinStr
             * if sinStr is of type Number convert it to string type
             */
            sinStr = sinStr.toString();
          }

          if (sinStr.length && sinStr.length == 9) {

            /*
             * @if
             * @description run the check if user input the full 9 digit SIN.
             */
            checkDigit = _.last(sinStr);

            /*
             * @var allNumArr:Array
             * @description initialize value of all nine digits as each element an array.
             */
            allNumArr = _.filter(sinStr.split(/(\d)/), function (v) {
              if (!_.isNaN(parseInt(v))) {

                /*
                 * @if
                 * only filter the elements that has a value and evaluated as number.
                 */
                return v;
              }
            });


            /*
             * @var oddNums
             * @return String
             */
            oddNums = _.chain(allNumArr).filter(function (v, i) {

              // initialize value as array of all odd-position-indexes digits
              if (i === initEvenIndex) {
                initEvenIndex = initEvenIndex += 2;
                return v;
              }
            }).map(function (v) {

              // multiply each element by 2
              return v * 2;
            }).value().join('');

            /*
             * @var evnNums
             * @return String
             */
            evnNums = _.chain(allNumArr).filter(function (v, i) {

              // initialize value as array of all evenly-position-indexes digits
              if (i === initOddIndex) {
                initOddIndex = initOddIndex += 2;
                return v;
              }

              // take the first 4 coz the last digit is the check-digit
            }).take(4).value().join('');

            // oddArr = _.filter(oddNums.split(/(\d)/), function(v){
            //   if (!_.isNaN(parseInt(v))) {
            //     return v;
            //   }
            // });
            // evnArr = _.filter(evnNums.split(/(\d)/), function(v){
            //   if (!_.isNaN(parseInt(v))) {
            //     return v;
            //   }
            // });

            /*
             * @var grandSum:Number
             * @description the total sum of the operations to get the check-digit value
             */
            grandSum = _.sum(evnNums) + _.sum(oddNums);

            if ((grandSum % 10 === 0) && grandSum % (grandSum / 10) === 0) {

              /*
               * @if grandSum ends in 0
               * take it as it is
               */
              checkSum = grandSum;
            } else {

              /*
               * @else
               * get the next number that ends in 0 from grandSum
               */

              if (_.ceil) {
                checkSum = _.ceil((grandSum + 1) / 10) * 10;
              } else {
                checkSum = Math.ceil((grandSum + 1) / 10) * 10;
              }
            }

            console.log('@validateSin (evnNums, oddNums, grandSum, checkSum, checkDigit) ', evnNums, oddNums, grandSum, checkSum, checkDigit);

            /*
             * @description it is a valid SIN – if the difference of `checkSum and `grandSum is equal to `checkDigit
             */
            return ((checkSum - grandSum) == checkDigit);
          }// if
          //DSO-12648 validate  empty and in-correct SIN number
          else {
            return false;
          }

        },
        formatTime: function (slotsRow, duration) {
          if (angular.isArray(slotsRow)) {
            return _.result(_.find(slotsRow, function (slot) {
              return slot.slotIndex !== -1;
            }), duration);
          }
        },

        parseFormatTimeSlots: function (timeSlots) {

          if (timeSlots) {

            // handle valid timeSlots

            // format
            timeSlots = _.chain(timeSlots)
              .values()
              .sortBy(function (v) {
                return moment(v[0].startTime).hour();
              })
              .map(function (bv) {
                bv = _.chain(bv)
                  .sortByOrder(function (av) {
                    return moment(av.startTime).format();
                  }, ['asc'])
                  .value();
                return bv;
              })
              .value();

            // take first 5 days everytime
            timeSlots = _.chain(timeSlots).map(function (v) {

              v = _.take(v, 5);
              return v;

            }).value();

            var _hasNoAvailableAppt = _.chain(timeSlots).map(function (v) {

                // console.log('_hasNoAvailableAppt INPROG ARR ', v);
                return _.result(_.find(v, { appointmentAvailable: true }), 'appointmentAvailable');


              })
              .every(_.isUndefined)
              .value();

            // console.log('_hasNoAvailableAppt ', _.every(_hasNoAvailableAppt, _.isUndefined));
            if (_hasNoAvailableAppt) {
              return [];
            } else {
              return timeSlots;
            }

            // /if
          }
        },
        parseRowHasAvailableTimeSlots: function (row) {
          return _.result(_.find(row, { appointmentAvailable: true }), 'appointmentAvailable');
        },
        getTimeFormat: function () {
          var _lang = buyUtils.getAppLang();
          switch (_lang) {
            case 'en':
              return 'h:mm a';
            case 'fr':
              return 'HH:mm';
            default:
              return 'hh:mm a';
          }
        },
        getFormTemplate: function (id) {
          var views, baseTplUrl = 'modules/checkout/views/fragments/';

        views = {
          1: baseTplUrl + 'credit-card.html',
          2: baseTplUrl + 'drivers-license.html',
          3: baseTplUrl + 'sin.html',
          4: baseTplUrl + 'passport.html',
          5: baseTplUrl + 'birth-certificate.html',
          6: baseTplUrl + 'citizenship.html',
          7: baseTplUrl + 'senior-citizen.html',
          8: baseTplUrl + 'employer.html',
          9: baseTplUrl + 'student-permit.html'
        };
        return views[id];
      },
      formatDriverLicense: function(region, number){
        if (region && number) {
          region = angular.lowercase(region);
          number = number.toString();
          switch(region) {
            case 'ab':
              // '(\\d{6}\\-\\d{3})',
              if (number.indexOf('-') >= 0) break;
              number = number.split('');
              number.splice(6,0,'-');
              number = number.join('');
              break;
            case 'mb':
              // '([a-zA-Z]{2}\\-[a-zA-Z]{2}\\-[a-zA-Z]{2}\\-[a-zA-Z]{1}\\d{3}[a-zA-Z]{2})',
              if (number.indexOf('-') >= 0) break;
              number = number.split('');
              number.splice(2,0,'-'); // ab-cdefg123hi
              number.splice(5,0,'-'); // ab-cd-efg123hi
              number.splice(8,0,'-'); // ab-cd-ef-g123hi
              number = number.join('');
              break;
            case 'on':
              // '([a-zA-Z]{1}\\d{4}\\-\\d{5}\\-\\d{5})',
              if (number.indexOf('-') >= 0) break;
              number = number.split('');
              number.splice(5,0,'-'); // a1234-1234512345
              number.splice(11,0,'-'); // a1234-12345-12345
              number = number.join('');
              break;
            case 'qb':
              // '([a-zA-Z]{1}\\d{4}\\-\\d{6}\\-\\d{2})',
              if (number.indexOf('-') >= 0) break;
              number = number.split('');
              number.splice(5,0,'-'); // a1234-12345612
              number.splice(12,0,'-');
              number = number.join('');
              break;
            case 'bc':
              // '(\\d{7})'
              case 'nb':
              // '(\\d{7})'
              case 'nl':
              // '([a-zA-Z]{1}\\d{9})'
              case 'ns':
              // '([a-zA-Z]{5}\\d{9})'
              case 'pe':
              // '(\\d{1,6})'
              case 'nt':
              // '(\\d{6})'
              case 'sk':
              // '(\\d{8})
              default:
            }
          }
          console.log('++++ ', region, number);
          return number;
        }

      };

      return buyUtils;
    }]);

})();
